import authInterceptor from "../AuthInterceptor";

export const ExcludedAPI = {
    rejectedCompletedList: (config = {}) =>
        authInterceptor.get(`ranking-api/rejected-completed/`, config)
            .then((response) => response.data)
            .catch((error) => error.response),
    removeInList: (bodyData) =>
        authInterceptor.post(`ranking-api/rejected-completed/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response)
}